import script from "./TextWithButton.vue?vue&type=script&setup=true&lang=js"
export * from "./TextWithButton.vue?vue&type=script&setup=true&lang=js"

import "./TextWithButton.vue?vue&type=style&index=0&id=2abc3c03&lang=scss"

const __exports__ = script;

export default __exports__